module.exports = __webpack_public_path__ + "img/download-tile-bg-mobile_cn.6eb236d.jpg";